import styled, { css } from "styled-components";

export default styled.button`
    display: inline-block;
    padding: 8px 10px;
    margin: 4px;
    background-color: ${p => p.theme.c.snowOnActive};
    border: ${p => p.theme.c.whiteOnActive} solid 2px;
    box-sizing: border-box;
    width: 200px;
    text-align: center;
    color: ${p => p.theme.c.whiteOnActive};
    font-size: 24px !important;
    font-weight: 500;
    cursor: pointer;

    a {
        text-decoration: none;
        text-transform: uppercase;
        cursor: pointer;
        width: 100%;
    }

    ${p =>
        p.theme.sm.max(css`
            padding: 5px 8px;
            font-size: 20px;
        `)}
`;
